module.exports = __webpack_public_path__ + "static/compare-6965aba648a159a21954709090fe13e2.jpg";